
export const DATA: any = {
    options:{
        thermals: [
            {value: 0.11, viewValue: '0.11 W/m²K'},
            {value: 0.12, viewValue: '0.12 W/m²K'},
            {value: 0.13, viewValue: '0.13 W/m²K'},
            {value: 0.14, viewValue: '0.14 W/m²K'},
            {value: 0.15, viewValue: '0.15 W/m²K'},
            {value: 0.16, viewValue: '0.16 W/m²K'},
            {value: 0.17, viewValue: '0.17 W/m²K'},
            {value: 0.18, viewValue: '0.18 W/m²K'},
            {value: 0.19, viewValue: '0.19 W/m²K'},
            {value: 0.20, viewValue: '0.20 W/m²K'},
            {value: 0.21, viewValue: '0.21 W/m²K'},
            {value: 0.22, viewValue: '0.22 W/m²K'},
            {value: 0.23, viewValue: '0.23 W/m²K'},
            {value: 0.24, viewValue: '0.24 W/m²K'},
            {value: 0.25, viewValue: '0.25 W/m²K'}

          ],
        
          acoustics: [
            // {value: '38', viewValue: 'Rw 38 dB'},
            // {value: '39', viewValue: 'Rw 39 dB'},
            // {value: '40', viewValue: 'Rw 40 dB'},
            {value: 41, viewValue: 'Rw 41 dB'},
            {value: 42, viewValue: 'Rw 42 dB'},
            {value: 43, viewValue: 'Rw 43 dB'},
            {value: 44, viewValue: 'Rw 44 dB'},
            {value: 45, viewValue: 'Rw 45 dB'},
            {value: 46, viewValue: 'Rw 46 dB'},
            {value: 47, viewValue: 'Rw 47 dB'},
            {value: 48, viewValue: 'Rw 48 dB'}
            // {value: '49', viewValue: 'Rw 49 dB'}

          ],
        
          roomTypes: [],
        
          workTypes: [
            {value: 0, viewValue: 'New Build'},
            {value: 1, viewValue: 'Refurbishment'}
          ],
        
          strengths: [
            // {value: 30, viewValue: '30 kPa'},
            {value: 65, viewValue: '65 kPa'},
            {value: 175, viewValue: '175 kPa'}
          ],
        
          pointLoads: [
            // {value: 450, viewValue: '450 N'},
            {value: 650, viewValue: '650 N'},
            {value: 2000, viewValue: '2000 N'},
        
          ]
    },
    roomsData:null,
    mainData:null,
    results:{

    }
}